(function(root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.HanezzaFilterController = api;
  if (root && root.document) api.autoInstall(root.document);
})(typeof globalThis !== 'undefined' ? globalThis : this, function() {
  'use strict';

  function setExpanded(group, expanded) {
    if (!group) return false;
    var isExpanded = Boolean(expanded);
    var extras = typeof group.querySelectorAll === 'function'
      ? group.querySelectorAll('[data-filter-extra]')
      : [];
    Array.prototype.forEach.call(extras, function(item) {
      item.hidden = !isExpanded;
    });
    var toggle = typeof group.querySelector === 'function'
      ? group.querySelector('[data-filter-more]')
      : null;
    if (toggle) {
      toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      toggle.textContent = isExpanded ? 'Daha az' : 'Daha fazla';
    }
    return isExpanded;
  }

  function getFocusable(dialog) {
    if (!dialog || typeof dialog.querySelectorAll !== 'function') return [];
    return Array.prototype.filter.call(
      dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function(node) {
        return !node.hidden && node.getAttribute && node.getAttribute('aria-hidden') !== 'true';
      }
    );
  }

  function createDialogController(options) {
    options = options || {};
    var dialog = options.dialog;
    var trigger = options.trigger;
    var closeButtons = options.closeButtons || [];
    var overlay = options.overlay || null;
    var doc = options.documentRef || (typeof document !== 'undefined' ? document : null);
    var returnFocus = null;
    var openState = false;

    if (!dialog || !trigger) throw new TypeError('dialog and trigger are required');

    function syncOverlay(open) {
      if (!overlay) return;
      overlay.hidden = !open;
      if (overlay.classList && typeof overlay.classList.toggle === 'function') {
        overlay.classList.toggle('open', open);
      }
    }

    function open() {
      if (openState) return;
      openState = true;
      returnFocus = doc && doc.activeElement ? doc.activeElement : trigger;
      dialog.removeAttribute('inert');
      dialog.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      if (dialog.classList && typeof dialog.classList.add === 'function') dialog.classList.add('open');
      syncOverlay(true);
      var focusTarget = typeof dialog.querySelector === 'function'
        ? dialog.querySelector('[data-filter-close], [data-filter-heading], button, [href], input, select')
        : null;
      if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus();
    }

    function close() {
      if (!openState && dialog.getAttribute && dialog.getAttribute('aria-hidden') === 'true') {
        trigger.setAttribute('aria-expanded', 'false');
        return;
      }
      openState = false;
      if (dialog.classList && typeof dialog.classList.remove === 'function') dialog.classList.remove('open');
      dialog.setAttribute('aria-hidden', 'true');
      dialog.setAttribute('inert', '');
      trigger.setAttribute('aria-expanded', 'false');
      syncOverlay(false);
      var target = returnFocus || trigger;
      if (target && typeof target.focus === 'function' && target.isConnected !== false) target.focus();
      returnFocus = null;
    }

    Array.prototype.forEach.call(closeButtons, function(button) {
      if (button && typeof button.addEventListener === 'function') {
        button.addEventListener('click', function(event) {
          if (event && typeof event.preventDefault === 'function') event.preventDefault();
          close();
        });
      }
    });

    if (overlay && typeof overlay.addEventListener === 'function') {
      overlay.addEventListener('click', close);
    }

    if (typeof dialog.addEventListener === 'function') {
      dialog.addEventListener('keydown', function(event) {
        if (!event) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
          return;
        }
        if (event.key !== 'Tab' || !openState) return;
        var focusable = getFocusable(dialog);
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && doc && doc.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && doc && doc.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    return { open: open, close: close, isOpen: function() { return openState; } };
  }

  function bindFilterDrawer(root) {
    root = root || (typeof document !== 'undefined' ? document : null);
    if (!root || typeof root.querySelector !== 'function') return null;
    if (root.__hanezzaFilterControllerInstalled) return root.__hanezzaFilterControllerInstalled;

    var trigger = root.querySelector('[data-filter-open]');
    var dialog = root.querySelector('[data-filter-drawer]');
    if (!trigger || !dialog) return null;
    var overlay = root.querySelector('[data-filter-overlay]');
    var closeButtons = dialog.querySelectorAll ? dialog.querySelectorAll('[data-filter-close]') : [];
    var controller = createDialogController({
      dialog: dialog,
      trigger: trigger,
      closeButtons: closeButtons,
      overlay: overlay,
      documentRef: root
    });

    trigger.addEventListener('click', function(event) {
      event.preventDefault();
      controller.open();
    });

    if (typeof root.querySelectorAll === 'function') {
      root.querySelectorAll('[data-filter-group]').forEach(function(group) {
        var button = group.querySelector('[data-filter-more]');
        if (!button) return;
        button.addEventListener('click', function(event) {
          event.preventDefault();
          var expanded = button.getAttribute('aria-expanded') === 'true';
          setExpanded(group, !expanded);
        });
      });

      root.querySelectorAll('[data-sort-toggle]').forEach(function(button) {
        var targetId = button.getAttribute('aria-controls');
        var menu = targetId && root.getElementById ? root.getElementById(targetId) : null;
        if (!menu) return;
        button.addEventListener('click', function(event) {
          event.preventDefault();
          var open = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', open ? 'false' : 'true');
          menu.classList.toggle('open', !open);
        });
      });
    }

    root.__hanezzaFilterControllerInstalled = controller;
    return controller;
  }

  function autoInstall(doc) {
    if (!doc) return;
    function start() { bindFilterDrawer(doc); }
    if (doc.readyState === 'loading' && typeof doc.addEventListener === 'function') {
      doc.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  }

  return {
    setExpanded: setExpanded,
    createDialogController: createDialogController,
    bindFilterDrawer: bindFilterDrawer,
    autoInstall: autoInstall
  };
});